import { Box } from "@mui/material";
import avatar from "../../../../../assets/images/home/comment-avatar.png";
import Text from "../../../../../components/ui/Text";

export const User = () => {
  return (
    <Box
      sx={{
        display: "flex",
        alignItems: "center",
        gap: 2,
        mt: { xs: 2, md: 4 },
      }}
    >
      <Box
        component="img"
        src={avatar}
        alt="User Avatar"
        sx={{
          width: 62,
          height: 62,
          border: "4px solid #E5E5E5",
          borderRadius: "50%",
          objectFit: "cover",
        }}
      />
      <Box>
        <Text
          component="p"
          sx={{
            fontSize: 18,
            fontWeight: 700,
          }}
        >
          Dermot O.
        </Text>
        <Text
          component="p"
          sx={{
            fontSize: 14,
            color: "#203FA9",
          }}
        >
          Emerging Sporting Vikings 🛠️
        </Text>
      </Box>
    </Box>
  );
};
